import { c as _c } from "react/compiler-runtime";
import { useActionsContext, usePanelContext } from "../context";
import { RiSearchLine } from "react-icons/ri";
export function Search() {
  const $ = _c(19);
  const {
    searchQuery,
    searchInputRef
  } = usePanelContext();
  const {
    setSearchQuery,
    setSearchInputFocused
  } = useActionsContext();
  let t0;
  if ($[0] !== searchInputRef) {
    t0 = () => {
      const menu = searchInputRef.current?.closest("[role=\"menu\"]");
      if (!menu) {
        return [];
      }
      return Array.from(menu.querySelectorAll("[role=\"menuitem\"]:not([data-disabled]), [role=\"menuitemcheckbox\"]:not([data-disabled])"));
    };
    $[0] = searchInputRef;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getMenuItems = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <RiSearchLine className="pointer-events-none absolute left-2 top-1/2 size-4 -translate-y-1/2 text-foreground-muted" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== setSearchQuery) {
    t2 = e => setSearchQuery(e.target.value);
    $[3] = setSearchQuery;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] !== setSearchInputFocused) {
    t3 = () => setSearchInputFocused(true);
    t4 = () => setSearchInputFocused(false);
    $[5] = setSearchInputFocused;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== getMenuItems || $[9] !== searchQuery || $[10] !== setSearchQuery) {
    t5 = e_0 => {
      if (e_0.nativeEvent.isComposing) {
        return;
      }
      if (e_0.key === "Escape" && searchQuery) {
        e_0.preventDefault();
        e_0.stopPropagation();
        setSearchQuery("");
        return;
      }
      if (e_0.key === "ArrowDown") {
        const items = getMenuItems();
        if (items.length === 0) {
          return;
        }
        e_0.preventDefault();
        e_0.stopPropagation();
        items[0].focus();
        return;
      }
      if (e_0.key === "ArrowUp") {
        const items_0 = getMenuItems();
        if (items_0.length === 0) {
          return;
        }
        e_0.preventDefault();
        e_0.stopPropagation();
        items_0[items_0.length - 1].focus();
        return;
      }
      if (e_0.key === "Enter" && searchQuery.trim().length > 0) {
        const items_1 = getMenuItems();
        if (items_1.length === 0) {
          return;
        }
        e_0.preventDefault();
        e_0.stopPropagation();
        items_1[0].click();
      }
    };
    $[8] = getMenuItems;
    $[9] = searchQuery;
    $[10] = setSearchQuery;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== searchInputRef || $[13] !== searchQuery || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <div className="border-b border-border p-2"><div className="relative">{t1}<input ref={searchInputRef} type="search" name="table-filter-search" value={searchQuery} onChange={t2} onFocus={t3} onBlur={t4} onKeyDown={t5} placeholder="Filter..." className="h-8 w-full rounded-md border-none bg-muted/50 pl-8 pr-2 text-body text-foreground shadow-none outline-none placeholder:text-foreground-muted focus:ring-0 [&::-webkit-search-cancel-button]:hidden" autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck={false} data-1p-ignore={true} data-lpignore="true" data-form-type="other" /></div></div>;
    $[12] = searchInputRef;
    $[13] = searchQuery;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}